import { tokens } from "@fluentui/react-components";

export const WORKSPACE_ICON_COLOR = "rgb(50, 49, 48)";
export const WORD_ICON_COLOR = "#2A5699";
export const EXCEL_ICON_COLOR = "#217346";
export const POWER_POINT_ICON_COLOR = "#B7472A";
export const OUTLOOK_ICON_COLOR = "#0078D4";
export const PDF_ICON_COLOR = "#D63649";
export const IMAGE_ICON_COLOR = "#E68C1F";

export const BORDER_COLOR = tokens.colorNeutralStroke1;
export const LINK_COLOR = tokens.colorBrandForeground1;

export const PROGRESS_BG_INSERTED = "#d9e4f2";
export const PROGRESS_BG_DELETED = "#f0dedd";
export const PROGRESS_BG_UNCHANGED = "#f3f3f3";
